/**
 * Per-center color palette for visual identification across
 * dashboard summary cards, navigation drawer, and other multi-center views.
 */

const CENTER_PALETTE: string[] = [
  '#06C8FF', // 0 - Apex Cyan (Résumé)
  '#FFA020', // 1 - Orange Vif (→ GoControl)
  '#B34BFF', // 2 - Violet Vif (→ GoKarts)
  '#00D48A', // 3 - Émeraude
  '#EF3B3B', // 4 - Rouge Vif (→ GoRacing)
  '#B8E600', // 5 - Lime Électrique
  '#FF4DA6', // 6 - Rose Vif
  '#4B9FFF', // 7 - Bleu Vif
]

/**
 * Returns the hex color for a center based on its index in the list.
 * Cycles with modulo for 8+ centers.
 */
export function getCenterColor(index: number): string {
  return CENTER_PALETTE[index % CENTER_PALETTE.length]
}

/**
 * Color 0 is reserved for the dashboard summary.
 * Centers start at color index 1.
 */
export function getCenterColorById(centerId: number, centers: { id: number }[]): string {
  const index = centers.findIndex(c => c.id === centerId)
  if (index === -1) return CENTER_PALETTE[1]
  return getCenterColor(index + 1)
}
